// Date-only string formatter. NO Date(), NO timezone conversion.
// Input: "YYYY-MM-DD"  Output: "MM/DD/YYYY"
export function formatDateOnlyYYYYMMDD(dateStr) {
  if (!dateStr || typeof dateStr !== "string") return "";
  const [y, m, d] = dateStr.split("-");
  if (!y || !m || !d) return dateStr;
  return `${m}/${d}/${y}`;
}

function formatISODateParts(year, month, day) {
  return `${String(year).padStart(4, "0")}-${String(month).padStart(2, "0")}-${String(
    day
  ).padStart(2, "0")}`;
}

function isValidDateParts(year, month, day) {
  if (!Number.isFinite(year) || !Number.isFinite(month) || !Number.isFinite(day)) {
    return false;
  }
  if (month < 1 || month > 12) return false;
  if (day < 1 || day > 31) return false;
  const candidate = new Date(year, month - 1, day);
  return (
    candidate.getFullYear() === year &&
    candidate.getMonth() === month - 1 &&
    candidate.getDate() === day
  );
}

// Normalize date-only strings without UTC shifting.
export function toISODateString(value) {
  if (!value) return null;
  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) return null;
    return formatISODateParts(
      value.getFullYear(),
      value.getMonth() + 1,
      value.getDate()
    );
  }
  if (typeof value !== "string") return null;
  const trimmed = value.trim();
  if (!trimmed) return null;
  if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
    const [year, month, day] = trimmed.split("-").map((part) => Number(part));
    return isValidDateParts(year, month, day)
      ? formatISODateParts(year, month, day)
      : null;
  }
  const slashMatch = trimmed.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (!slashMatch) return null;
  const month = Number(slashMatch[1]);
  const day = Number(slashMatch[2]);
  const year = Number(slashMatch[3]);
  return isValidDateParts(year, month, day)
    ? formatISODateParts(year, month, day)
    : null;
}
